(async () => {
  if (!customElements.get('how-to-use')) {
    class HowToUse extends HTMLElement {
      constructor() {
        super();

        this.tabsContainer = this.querySelector('.tabs-container');
        this.tabsList = this.tabsContainer.querySelector('ul');
        this.tabButtons = this.tabsList.querySelectorAll('a');
        this.tabPanels = this.querySelectorAll('.tab__panels > div');
        this.tabVideos = this.querySelectorAll('.tab__videos > div');

        if (this.tabButtons.length == 0 || this.tabPanels.length === 0) {
          return;
        }

        this.init();
      }

      init() {
        this.tabsList.setAttribute('role', 'tablist');

        this.tabsList.querySelectorAll('li').forEach(li => { 
          li.setAttribute('role', 'presentation');
        });

        this.tabButtons.forEach((button, index) => {
          button.setAttribute('role', 'tab');

          if (index === 0) {
            button.setAttribute('aria-selected', 'true');
          } else {
            button.setAttribute('tabindex', '-1');
            this.tabPanels[index].setAttribute('hidden', '');
            this.tabVideos[index].setAttribute('hidden', '');
          }
        });

        this.tabPanels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('tabindex', '0');
        });

        this.tabsContainer.addEventListener('click', event => {
          const clickedTab = event.target.closest('a');

          if (!clickedTab) return;

          event.preventDefault();

          this.activateTab(clickedTab);
        });

        this.tabsContainer.addEventListener('keydown', event => {
          switch(event.key) {
            case 'ArrowLeft':
              event.preventDefault();
              this.moveLeft();
              break;
            case 'ArrowRight':
              event.preventDefault();
              this.moveRight();
              break;
            case 'Home':
              event.preventDefault();
              this.activateTab(this.tabButtons[0]);
              break;
            case 'End':
              event.preventDefault();
              this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
              break;
          }
        });
      }

      moveLeft() {
        const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
        const previousTab = activeTab.parentNode.previousElementSibling;

        if (!previousTab) {
          this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
        } else {
          this.activateTab(previousTab.querySelector('a'));
        }
      }

      moveRight() {
        const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
        const nextTab = activeTab.parentNode.nextElementSibling;

        if (!nextTab) {
          this.activateTab(this.tabButtons[0]);
        } else {
          this.activateTab(nextTab.querySelector('a'));
        }
      }

      activateTab(clickedTab) {
        const activePanelId = clickedTab.getAttribute('href');
        const activePanel = this.querySelector(activePanelId + '-panel');
        const activeVideoContainer = this.querySelector(activePanelId + '-video');

        this.tabButtons.forEach(button => {
          button.setAttribute('aria-selected', 'false');
          button.classList.remove('button--primary', 'button--active');
          button.classList.add('button--secondary');
          const buttonNumber = button.querySelector('.how-to-use__tab-number');
          buttonNumber.classList.remove('button--secondary', 'button--active');
          buttonNumber.classList.add('button--primary');
          button.setAttribute('tabindex', '-1');
        });

        this.tabPanels.forEach(panel => {
          panel.setAttribute('hidden', '');
        });

        this.tabVideos.forEach(videoContainer => {
          const video = videoContainer.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
          videoContainer.setAttribute('hidden', '');
        });

        activePanel.removeAttribute('hidden');
        activeVideoContainer.removeAttribute('hidden');
        const activeVideo = matchMedia(`(max-width: 767px)`).matches ? activeVideoContainer.querySelector('.visibility-md--hidden video') : activeVideoContainer.querySelector('.visibility-md--visible video');
        if (activeVideo && this.hasAttribute('data-autoplay')) {
          activeVideo.play();
        }

        clickedTab.setAttribute('aria-selected', 'true');
        clickedTab.classList.remove('button--secondary');
        clickedTab.classList.add('button--primary', 'button--active');
        const clickedTabNumber = clickedTab.querySelector('.how-to-use__tab-number');
        clickedTabNumber.classList.remove('button--primary');
        clickedTabNumber.classList.add('button--secondary', 'button--active');
        clickedTab.setAttribute('tabindex', '0');
        activePanel.focus();
      }
    }

    customElements.define('how-to-use', HowToUse);
  }
})();